import { render, staticRenderFns } from "./Test3.vue?vue&type=template&id=63581c22"
import script from "./Test3.vue?vue&type=script&lang=js"
export * from "./Test3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports